import { Button, EditIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type EditViewButtonProps = {
  viewId: string;
};

export const EditViewButton: React.FC<EditViewButtonProps> = ({ viewId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();


  return (
    <Button
      key="view-edit"
      icon={<EditIcon />}
      onClick={async () => {
        navigate(`/reporting/machine/status/views/` + viewId);
      }}

    >
      {t("reporting.machinestatus.view.actions.update.button")}

    </Button>
  );
};
